import moment from "moment/moment";
import React from "react";

const PtoLinkLabel = (props) => {
    /** 
     * @type {{
     *  direction: "left" | "right",
     *  hideDate: boolean,
     *  date: import("moment/moment").Moment
     * }}
     */
    const { direction, hideDate, date, hidden } = props;
    const d = moment(date);
    const sDate = d.format("MM/DD/YY");
    const caretStyle = {        
        color: "green",
        fontSize: 18,
        verticalAlign: "middle",
        lineHeight: "10px",
    };

    if (!!!hidden && date) {
        if (direction === "right") {
            return (
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: 10, fontSize: 9 }} title={sDate} >
                    <div style={{ whiteSpace: "nowrap" }}>{hideDate ? "" : sDate} <i className="fa fa-caret-right" style={caretStyle}></i></div>
                </div>
            );
        } else {
            return (
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: 10, fontSize: 9 }} title={sDate} >
                    <div style={{ whiteSpace: "nowrap" }}><i className="fa fa-caret-left" style={caretStyle}></i> {hideDate ? "" : sDate}</div>
                </div>
            );
        }
    } else {
        return <div style={{ width: 5 }}> </div>;
    }
};

export default PtoLinkLabel;